import React from "react";
import BasePage from "../../components/ui/BasePage";
import AddReleaseNoteContainer from "../../components/ReleaseNotes/AddReleaseNoteContainer";

export default function AddReleaseNotePage() {
    return (
        <BasePage>
            <AddReleaseNoteContainer />
        </BasePage>
    );
}
